import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { BrowserRouter as Router } from "react-router-dom";
import { SnackbarProvider } from "notistack";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import appTheme from "./theme/appTheme";
import AppRouter from "./router";
import "./App.css";

function App() {
  return (
    <>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <ThemeProvider theme={appTheme}>
          <SnackbarProvider
            autoHideDuration={2000}
            preventDuplicate
            anchorOrigin={{ horizontal: "right", vertical: "top" }}
            dense="true"
            maxSnack={3}
          >
            <Router>
              <AppRouter />
            </Router>
          </SnackbarProvider>
        </ThemeProvider>
      </LocalizationProvider>
    </>
  );
}

export default App;
